export default {"src":"/_next/static/media/expandWhite.b097abf5.svg","height":9,"width":16};